window.onload = function () {
  let t = 0,
    e = setInterval(function a() {
      if (t < 50) {
        if ('GB' === iso_country) {
          let i = $(
            '.size-option, [data-tabs-relocate=".lifetime"], [data-tabs-relocate=".rush"], [data-tabs-relocate=".size-option"]'
          );
          i.length && i.remove();
          let o = document.querySelectorAll('a[data-href]');
          o.forEach(function (t) {
            let e = t.getAttribute('data-href');
            e && t.setAttribute('href', e);
          });
        } else {
          let l = $(
            '.size-optionuk, [data-tabs-relocate=".uk_lifetime"], [data-tabs-relocate=".uk_rush"], [data-tabs-relocate=".size-optionuk"]'
          );
          l.length && l.remove();
        }
        ++t >= 50 && clearInterval(e);
      }
      let n = $('#infiniteoptions-container');
      n.length && n.css('visibility', 'visible');
    }, 200);
};
